var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoActivBiblio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 127,
    viewBox: "0 0 208 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2018_9770)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M92.5745 7.53327L121.848 126.852L151.912 119.324L122.639 0.00576061L92.5745 7.53327Z",
    fill: "#EAF0F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.637 25.7661L153.438 126.853L178.369 120.61L153.568 19.5238L128.637 25.7661Z",
    fill: "#DDEAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1981 4.7168H18.2554V46.7227H92.1981V4.7168Z",
    fill: "#DDEAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1485 46.8203H0V84.7958H73.1485V46.8203Z",
    fill: "#B4CAE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.923 84.998H11.1226V127.004H98.923V84.998Z",
    fill: "#DDEAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.212 26.9678L127.57 83.4551L143.354 101.889L207.996 45.4018L192.212 26.9678Z",
    fill: "#B4CAE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.432 87.1084L118.556 107.47L139.205 105.536L123.432 87.1084Z",
    fill: "#B4CAE4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2018_9770"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 208,
    height: 127,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoActivBiblio);
export default __webpack_public_path__ + "static/media/no_activ_biblio.7f797798abcc7c27ecc2df56f80bbb38.svg";
export { ForwardRef as ReactComponent };